import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/terminy_/$terminId")({
  beforeLoad: requirePermissionGuard("hca.terminy.read"),
});
